import { display } from '../lib/score.js'

/**
 * A score, always to one decimal and always in tabular figures.
 *
 * `mine` is what carries the accent colour. Across the whole product one
 * colour means "this is yours" — the community's numbers stay neutral, so a
 * page of scores can be read at a glance for which of them you wrote.
 */
export default function ScorePill({ score, mine = false, large = false, label, className = '' }) {
  const empty = score == null
  const classes = ['score-pill', mine && !empty ? 'mine' : '', large ? 'lg' : '', className]
    .filter(Boolean)
    .join(' ')

  if (empty) {
    return (
      <span className={`${classes} empty`} aria-label={label || 'Not rated'}>
        —
      </span>
    )
  }
  return (
    <span
      className={classes}
      aria-label={label || `${mine ? 'Your' : 'Community'} score ${display(score)} out of 10`}
    >
      {display(score)}
    </span>
  )
}
